export default {
  // MessageUsageJourney,Activity
  excelDownload: 'Download Excel',
  journeyName: 'Journey Name',
  journeyID: 'Journey ID',
  journeyVersion: 'Journey Version',
  journeyVersionID: 'Journey Version ID',
  activityName: 'Activity Name',
  activityId: 'Activity ID',
  journeyVersionStatistics: 'Journey Version Stats',
  allCount: 'All',
  successCount: 'Success',
  failbackCount: 'Resent',
  waitingCount: 'Pending',
  failCount: 'Failed',
  rejectCount: 'Unsubscribed',
  wrongRequests: 'Invalid Request',
  finishSendDate: 'Last Sent Date & Time',
  agentType: 'Agent Type',
  messageClType: 'Message Category',
  messageType: 'Message Type',
  content: 'Content',
  viewDetails: 'View Details',
  monthStatistics: 'Monthly Statistics',
  outgoingInformation: 'Sender Info',
  outgoingPhoneInfo: 'Sender Number',
  rejectPhoneInfo: 'Unsubscribe Number',
  msgClType: 'Sender Type',
  messageInformation: 'Message Info',
  tmpBook: 'Reservation Status',
  notiId: 'Sender ID',
  recipientNum: 'Recipient Number',
  reportCode: 'Sending Result (Code)',
  sentDate: 'Sent Date & Time',
  resultDate: 'Result Date & Time',
  failbackMessageType: 'Fallback Message Type',
  failbackReportCode: 'Fallback Sending Result (Code)',
  failbackSentDate: 'Fallback Sent Date & Time',
  failbackResultDate: 'Fallback Result Date & Time',
  message: 'Text Message',
  kakaoMessage: 'Kakao Message',
  typeSearch: 'Search by Type',
  typeInputAlert: 'Please enter a keyword for type search.',
  searchPeriod: 'Date',
  contentCaption: 'Content is displayed up to 100 characters.',
  monthOfUse: 'Usage Year & Month',
  recipientNumberSearch: 'Search by Recipient Number',
  recipientNumberSearchPlaceholder: 'Please enter a number.',
  waitingCaption: '"Pending" means the result is still being awaited.',
  recipientCaptionContent: 'To search by recipient number, please enter it without hyphens (-).',
  messageId: 'Message ID',
  sendResult: 'Send Result',
};
